export default "__VITE_ASSET__c4529bb5__"